@use '~/vendor/cxy/scss/styles/index.scss' as cxy;
@use 'sass:map';

$bar-chart-colors: (
  'above': var(--cxy-color-success),
  'below': var(--cxy-color-content-danger),
);

[data-fpsm-theme='gazzetta'] {
  --cxy-color-reference-line-label: var(--cxy-color-text-default-placeholder);

  .wrapper {
    :global {
      .recharts-reference-line line {
        stroke: var(--cxy-color-text-default-placeholder);
      }
    }
  }
}

.wrapper {
  color: var(--cxy-color-text-default-body);
  width: 100%;
  container-type: inline-size;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--cxy-spacing-xxsm);
  }

  .barChartWrapper,
  .bidirectionalBarChartWrapper {
    height: 400px;
  }

  .compactBarChartWrapper,
  .compactBidirectionalBarChartWrapper {
    height: 140px;
  }

  .barChartWrapper,
  .bidirectionalBarChartWrapper,
  .compactBarChartWrapper,
  .compactBidirectionalBarChartWrapper {
    :global {
      .recharts-xAxis .recharts-cartesian-axis-tick-value,
      .recharts-yAxis .recharts-cartesian-axis-tick-value {
        fill: var(--cxy-color-content-default);
      }

      .recharts-xAxis .recharts-cartesian-axis-line,
      .recharts-yAxis .recharts-cartesian-axis-line {
        stroke: transparent;
      }

      .recharts-yAxis-tick-labels .recharts-cartesian-axis-tick-value {
        fill: var(--cxy-color-content-default);
      }

      .recharts-tooltip-wrapper {
        .recharts-default-tooltip {
          background-color: var(--cxy-color-content-on-inverse) !important;
          border: var(--cxy-border-default) !important;

          .recharts-tooltip-label {
            color: var(--cxy-color-text-default-placeholder);
          }
        }
      }

      .recharts-surface {
        overflow: visible;
      }

      .recharts-reference-line line {
        stroke: var(--cxy-color-content-default);
        stroke-width: 2;
      }

      .recharts-reference-line.previous line {
        stroke: var(--cxy-color-content-default);
        stroke-dasharray: 3 3;
      }

      .recharts-line-curve {
        stroke: var(--cxy-color-content-subtle);
      }

      .bar-above {
        fill: map.get($bar-chart-colors, 'above');
      }

      .bar-below {
        fill: map.get($bar-chart-colors, 'below');
      }

      .reference-line-label {
        fill: var(--cxy-bar-chart-fill, var(--cxy-color-icon-black));
        @include cxy.font-size('text-xxs', var(--cxy-fontWeight-normal));

        rect {
          fill: var(--cxy-color-content-default);
        }
      }

      .dateAxis {
        @supports (container-type: inline-size) {
          @container (max-width: 768px) {
            display: none;
          }
        }
      }
    }
  }

  .otherLines {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--cxy-spacing-xxsm);
    padding: 0 var(--cxy-spacing-lg);

    .alternativeLines {
      display: flex;
      align-items: center;
      > * + * {
        margin-left: var(--cxy-spacing-xxsm);
      }

      .slider {
        width: 200px;
      }
    }

    .label {
      @include cxy.font-size('text-s', var(--cxy-fontWeight-bold));
    }
  }
}

.primaryAxis {
  height: 45px;
  color: var(--cxy-color-text-default-body);

  @supports (container-type: inline-size) {
    @container (min-width: 769px) {
      height: 5px;
    }
  }
}

.xAxisLabel {
  @include cxy.font-size('text-s', var(--cxy-fontWeight-normal));
  fill: var(--cxy-color-content-default);

  @supports (container-type: inline-size) {
    @container (min-width: 769px) {
      fill: var(--cxy-color-content-default);
      height: 5px;
      text-anchor: middle;
      transform: translateX(0);
    }

    @container (max-width: 768px) {
      height: 45px;
      font-size: 11px;
      transform: rotate(-90deg);
      transform-origin: 0 0;
      text-anchor: end;
    }
  }
}
